import moment from "moment";

import { BaseReactComponent } from "@/Common/Components/BaseReactComponent";
import { QuestionnaireNoticeBoardTable } from "./QuestionnaireNoticeBoardTable";

interface INoticeBoardProps {
    shouldReloadQuestionnaireBoard: boolean;
}

class NoticeBoard extends BaseReactComponent<INoticeBoardProps> {
    public render(): JSX.Element {
        return (
            <div className="workspace">
                <div className="myle-page-header bottom-border">
                    <h3 className="thin-font">{cacheStore.GetString("NoticesLabel")} - {moment().format("dddd, MMMM D, YYYY")}</h3>
                </div>
                <div className="hide-overflow" style={{ minHeight: "calc(100vh - 110px)" }}>
                    {this.renderContent()}
                </div>
            </div>
        );
    }

    private renderContent(): JSX.Element {
        return (
            <div style={{ padding: "20px" }}>
                <QuestionnaireNoticeBoardTable {...this.props} />
            </div>
        );
    }
}

export { NoticeBoard };
